import React from "react";
import { Modal } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";

export default function DeleteEmployeeSalModal({
  show,
  handleClose,
}) {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="delete-modal-wrapper"
    >
      <Modal.Body className="delete-modal-body">
        <div className="delete-icon-box">
          <FiTrash2 />
        </div>

        <h3>Confirm Delete</h3>

        <p>
          You want to delete all the marked items,
          this can not be undone once you delete.
        </p>

        <div className="delete-modal-actions">
          <button
            className="delete-cancel-btn"
            onClick={handleClose}
          >
            Cancel
          </button>

          <button className="delete-confirm-btn">
            Yes, Delete
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}